<template>
    <div class="container">
        <div v-if="gelen.hataVarMi">
            {{gelen.mesaj}}
        </div>
        <div v-else>
            <div class="my-3">
                <b-button v-if="geriDonuGoster" @click="geriGit()">
                    <b-icon icon="arrow-left"/>
                    Geri Dön
                </b-button>

                <b-form-select style="width: 50%; float: right;" v-model="filtre" :options=filtreler>
                    <template v-slot:first>
                        <b-form-select-option value="" disabled>Filtre Seçiniz</b-form-select-option>
                    </template>
                </b-form-select>

            </div>
            <div class="my-5" style="clear: both;" v-for="soru in okunamayanKelimeler" :key="soru.kelimeId"
                 @click="soruDetayaGit(soru.kelimeId)">
                <okunmayan-kelime  v-if="filtre===1  || (filtre===2 && soru.kisiId===kisi.kisiId)" :mesajYazGoster="false" :kelime="soru" :key="okunamayanKelimeKey"/>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'

    moment.locale('tr');

    import {GoogleTokenIleGirisYapmayiDene} from "@/utils/googlegiris";
    import {mapGetters} from "vuex";
    import {okunamayanlariGetir} from "@/api/okunamayan";
    import OkunmayanKelime from "@/components/OkunmayanKelime";

    export default {
        name: "okunamayankelimeler",
        data() {
            return {
                filtre: 1,
                filtreler: [
                    {text: 'Hepsi', value: 1},
                    {text: 'Sorduklarım', value: 2},
                ],
                gelen: {
                    hataVarMi: true,
                    mesaj: "Yükleniyor"
                },
                okunamayanKelimeler: [],
                geriDonuGoster: false,
                okunamayanKelimeKey: 0,
            }
        },
        watch: {
            async filtre(yeniDeger) {
                this.okunamayanKelimeler = await okunamayanlariGetir(yeniDeger);
                this.okunamayanKelimeKey = Date.now();
            }
        },
        methods: {
            resmiGetir(guid) {
                return process.env.VUE_APP_BASE_API_URL + "OkunamayanKelime/ResimGetir?guid=" + guid
            },
            aciklamayiGetir(mesajlar) {
                if (mesajlar.length === 0)
                    return "";
                return mesajlar[0].mesaj;
            },
            formatDate(tarih) {
                return moment(tarih).format('h:mm')
            },
            geriGit() {
                this.$router.go(-1)
            },
            soruDetayaGit(kelimeId) {
                let routeData = this.$router.resolve({name: 'sorudetay', params: {kelimeId: kelimeId}});
                window.open(routeData.href, '_blank');
            }
        },
        computed: {
            ...mapGetters([
                'bkCount', 'kisi', 'girisYapmismi'
            ])
        },
        async mounted() {

            if (this.girisYapmismi) {
                this.geriDonuGoster = true;
            } else {
                await new GoogleTokenIleGirisYapmayiDene(this);
            }

            if (!this.girisYapmismi) {
                this.gelen.mesaj = "Giriş yapmanız lazım";
                this.gelen.hataVarMi = true;

                setTimeout(() => {
                    this.$router.push("/giris-yap?url=" + encodeURI("/mektup"))
                }, 3000);
                return
            }
            this.gelen.hataVarMi = false;
            this.okunamayanKelimeler = await okunamayanlariGetir();

            const that = this;
            this.$signalr.on("okunamayanlarAnaSayfa", data => {
                that.okunamayanKelimeler = data;
                that.okunamayanKelimeKey = Date.now();
                that.scrollToBottom();
            });
        },
        components: {
            OkunmayanKelime,
        }
    }

</script>

<style scoped>

</style>
